import './index.scss';

import React from 'react';

export function Link({ value = 'Im Link!', url = '#' }) {
  return (
    <a className='nf-link' href={ url } > { value } </a>
  )
}